import {FlexUiStateProvider} from "./FlexUiStateProvider";
import {PropsWithChildren} from "react";
import {useAccountId} from "contexts";

const FlexUiStateWrapper = ({children}: PropsWithChildren) => {
  const accountId = useAccountId();
  return <FlexUiStateProvider accountId={accountId}>{children}</FlexUiStateProvider>;
};
export default FlexUiStateWrapper;
